import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import type { CSSProperties, FC } from 'react';

import { useAppTranslation } from '../../i18n';

const GenericLoader: FC<{
  iconOnly?: boolean;
  style?: CSSProperties;
}> = ({ iconOnly, style }) => {
  const { t } = useAppTranslation('survey-tool');
  const classes = useStyles();
  return (
    <div style={style} className={clsx(classes.loading)}>
      <div className={clsx(classes.spinner)}>
        <div className={clsx(classes.bounce, classes.bounce1)} />
        <div className={clsx(classes.bounce, classes.bounce2)} />
        <div className={clsx(classes.bounce)} />
      </div>
      {!iconOnly && <div className={clsx(classes.text)}>{t('loading', 'Loading')}</div>}
    </div>
  );
};

export const GenericLoaderNoI18N: FC<{
  style?: CSSProperties;
}> = ({ style }) => {
  const classes = useStyles();
  return (
    <div style={style} className={clsx(classes.loading)}>
      <div className={clsx(classes.spinner)}>
        <div className={clsx(classes.bounce, classes.bounce1)} />
        <div className={clsx(classes.bounce, classes.bounce2)} />
        <div className={clsx(classes.bounce)} />
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  '@keyframes bounce': {
    '0%': {
      transform: 'scale(0)',
    },
    '100%': {
      transform: 'scale(0)',
    },
    '40%': {
      transform: 'scale(1)',
    },
    '80%': {
      transform: 'scale(0)',
    },
  },
  bounce: {
    animationDuration: '1.4s',
    animationFillMode: 'forwards',
    animationIterationCount: 'infinite',
    animationName: '$bounce',
    animationTimingFunction: 'ease-in-out',
    backgroundColor: '#888',
    borderRadius: '100%',
    display: 'inline-block',
    height: '18px',
    width: '18px',
  },
  bounce1: {
    animationDelay: '-0.32s',
  },
  bounce2: {
    animationDelay: '-0.16s',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center',
    transform: 'scale(.5)',
  },
  spinner: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    minWidth: '70px',
  },
  text: {
    color: '#888',
    fontSize: '24px',
    paddingTop: '15px',
    textAlign: 'center',
  },
});

export default GenericLoader;
